import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AccSettingHeader from "./acc_setting_header";
import HeaderMenu from "../sidebar/headermenu";
import { API_STATUS } from "../../constants";
import { GetBlockUserApi } from "../../apis/user/get_blocked_userapi";
import { SearchUserApi } from "../../apis/user/search_user_api";
import PlaceHolder from "../../utils/placeholder";
import { BlockUserApi } from "../../apis/user/block_user_api";

export default function BlockedUsers() {
    const navigate = useNavigate();
    const [loginId, setLoginId] = useState("");
    const [loginType, setLoginType] = useState("");
    const [userData, setUserData] = useState("");
    const [error, setError] = useState("");
    const [getApi, setGetApi] = useState(API_STATUS);
    const [busers, setBusers] = useState([]);
    const [noResult, setNoResult] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [searchApi, setSearchApi] = useState(API_STATUS);
    const [searchKey, setSearchKey] = useState("");
    const [noData, setNodata] = useState(false);
    const [searchBox, setSearchBox] = useState(false);
    const [blockApi, setBlockApi] = useState(API_STATUS);

    useEffect(() => {
        setSearchData([]);
        if (!searchApi.isLoader && !searchApi.isError && searchApi.data != null) {
            if (searchApi.data.status === 1) {
                setSearchData(searchApi.data.data);
            } else {
                setNodata(true);
            }
        }
    }, [searchApi]);

    useEffect(() => {
        if (!blockApi.isLoader && !blockApi.isError && blockApi.data != null) {
            setSearchData([]);
            setSearchBox(false);
            setSearchKey("");

            GetBlockUserApi(setGetApi);
        }
    }, [blockApi]);

    const doSearch = () => {
        if (searchKey !== "") {
            setSearchData([]);
            setNodata(false);

            SearchUserApi({ 'search_key': searchKey }, setSearchApi);
        }
    }

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            const userCode = sessionStorage.getItem('USER_CODE');
            setLoginId(userCode);

            const utype = sessionStorage.getItem('USER_TYPE');
            setLoginType(utype);
        }
    }, []);

    useEffect(() => {
        const loginData = sessionStorage.getItem('LOGIN_DATA');
        if (loginData !== null) {
            const uData = JSON.parse(loginData);
            setUserData(uData);
        }
    }, []);

    useEffect(() => {
        if (!getApi.isLoader && !getApi.isError && getApi.data != null) {
            setBusers([]);
            console.log(getApi.data);
            if (getApi.data.status === 1) {
                setNoResult(false);
                setBusers(getApi.data.data);
            } else {
                setNoResult(true);
            }
        }
    }, [getApi]);

    useEffect(() => {
        GetBlockUserApi(setGetApi);
    }, []);

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            {
                userData !== "" &&

                <div className="max-w-2xl mx-auto px-1 py-1">
                    <div class="page__heading py-6 mt-6">
                        <a href={'/profile/' + loginId}>
                            <ion-icon name="chevron-back-outline"></ion-icon> Back
                        </a>
                        <h1>Account Settings </h1>
                    </div>

                    <AccSettingHeader userData={userData} activeTab={'blocked'} />

                    <div className="mt-6 mb-20 text-sm font-medium text-gray-600 dark:text-white/80">
                        <div className="uk-switcher bg-white border rounded-xl shadow-sm md:py-12 md:px-20 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">
                            <div className="uk-active" style={{ position: 'relative' }}>
                                <div>
                                    <div className="md:flex mb-5" style={{ justifyContent: 'space-between' }}>
                                        <h3 class="text-md text-base font-semibold text-black dark:text-white"> Blocked Users </h3>
                                        <Link onClick={() => {
                                            setSearchBox(true);
                                        }} className="font-semibold text-blue-600 border border-blue-500 px-3 py-1 rounded">+ Block</Link>
                                    </div>
                                    {
                                        searchBox &&

                                        <div>
                                            <div className="">

                                                <div className="py-1 flex">

                                                    <div className="px-2 relative -mx-1 flex-1">
                                                        <Link
                                                            onClick={doSearch}
                                                            className="absolute right-3" style={{ bottom: 8 }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" className="w-5 h-5">
                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                                            </svg>
                                                        </Link>

                                                        <input onChange={(v) => {
                                                            setSearchKey(v.target.value);
                                                        }} type="text" placeholder="Search" value={searchKey} className="bg-transparen w-full !py-2 !rounded-lg" style={{ paddingRight: 40 }} />

                                                    </div>

                                                    <button onClick={() => {
                                                        setSearchBox(false);
                                                        setSearchKey("");
                                                        setSearchData([]);
                                                    }} className="p-2"><i class="fa fa-times" aria-hidden="true"></i></button>

                                                </div>
                                                {
                                                    noData &&
                                                    <div className="p-3">No result found for {searchKey}</div>
                                                }
                                                {
                                                    searchApi.isLoader &&
                                                    <PlaceHolder />
                                                }
                                                {
                                                    searchData.length > 0 &&
                                                    <div class="p-2 space-y-2 dark:text-white">

                                                        <div class="flex items-center justify-between py-2.5 px-3 font-semibold">
                                                            <h4>Search Result</h4>
                                                        </div>
                                                        {
                                                            searchData.map((item, i) =>
                                                                <div key={i} class="relative flex items-center gap-3 p-2 duration-200 rounded-xl">
                                                                    <img src={item.userPic} alt="" class="bg-gray-200 rounded-full w-10 h-10" />
                                                                    <div class="flex-1 min-w-0">
                                                                        <h4 class="font-medium text-sm text-black dark:text-white">  {item.firstName + ' ' + item.lastName} </h4>
                                                                        <div class="text-xs text-gray-500 font-normal mt-0.5 dark:text-white-80"> {item.username} </div>
                                                                    </div>
                                                                    <button type="button"
                                                                        onClick={() => {
                                                                            BlockUserApi({ 'status': '0', 'userId': item.userId }, setBlockApi);
                                                                        }}
                                                                        class="text-sm rounded-full py-1.5 px-4 font-semibold bg-secondery"> Block </button>
                                                                </div>
                                                            )
                                                        }

                                                    </div>
                                                }


                                            </div>
                                        </div>
                                    }

                                    <div className="">
                                        {
                                            getApi.isLoader &&
                                            <PlaceHolder />
                                        }
                                        {
                                            busers.length > 0 &&
                                            <div>
                                                {
                                                    busers.map((item, i) =>
                                                        <div key={i} class="relative flex items-center gap-3 p-2 duration-200 rounded-xl">
                                                            <img src={item.user_pic} alt="" class="bg-gray-200 rounded-full w-10 h-10" />
                                                            <div class="flex-1 min-w-0">
                                                                <h4 class="font-medium text-sm text-black dark:text-white">  {item.first_name + ' ' + item.last_name} </h4>
                                                                <div class="text-xs text-gray-500 font-normal mt-0.5 dark:text-white-80"> {item.username} </div>
                                                            </div>
                                                            <button type="button"
                                                                onClick={() => {
                                                                    BlockUserApi({ 'status': '1', 'userId': item.block_id }, setBlockApi);
                                                                }}
                                                                class="text-sm rounded-full py-1.5 px-4 font-semibold bg-secondery"> Unblock </button>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        }
                                    </div>

                                    {
                                        blockApi.isLoader &&
                                        <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center' }}>
                                            <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                                            <span class="sr-only">...</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </main>
    </div>
}